import {
  FIXED_ADMIN_LOGIN,
  FIXED_ADMIN_MENUS as LEGACY_FIXED_ADMIN_MENUS,
  FIXED_ADMIN_USER,
  FIXED_TENANT_LOGIN,
  FIXED_TENANT_MENUS,
  FIXED_TENANT_USER,
  type LocalMenuItem,
} from "./mockAuth";

const MENU_MANAGE_ITEM: LocalMenuItem = {
  name: "菜单管理",
  path: "/system/menu-manage",
  icon: "MenuOutlined",
};

const patchAdminMenus = (menus: LocalMenuItem[]): LocalMenuItem[] =>
  menus.map((menu) => {
    if (menu.path !== "/system") {
      return menu;
    }

    const routes = [...(menu.routes || menu.children || [])];
    const exists = routes.some((item) => item.path === MENU_MANAGE_ITEM.path);
    if (!exists) {
      const insertIndex = routes.findIndex((item) => item.path === "/system/params");
      if (insertIndex >= 0) {
        routes.splice(insertIndex, 0, MENU_MANAGE_ITEM);
      } else {
        routes.push(MENU_MANAGE_ITEM);
      }
    }

    return {
      ...menu,
      routes,
    };
  });

export const FIXED_ADMIN_MENUS = patchAdminMenus(LEGACY_FIXED_ADMIN_MENUS);

export {
  FIXED_ADMIN_LOGIN,
  FIXED_ADMIN_USER,
  FIXED_TENANT_LOGIN,
  FIXED_TENANT_MENUS,
  FIXED_TENANT_USER,
};
